
/**
 * Module dependencies.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

/**
 * `Tracker` type.
 */

type Tracker = {
  gaOptions: {
    name: string;
  };
  trackingId: string;
};

/**
 * `Options` type.
 */

type Options = {
  gaOptions: {
    debug: boolean;
  };
  payspaceSlug: string | null | undefined;
  trackers: Array<Tracker>;
};

/**
 * Export `initializeAnalytics`.
 */

export function initializeAnalytics(options: Options) {
  const { gaOptions, payspaceSlug, trackers } = options;

  if (trackers.length === 0) {
    return { AnalyticsTracker: () => null };
  }

  const trackerNames = trackers.map(({ gaOptions }) => gaOptions.name);
  const [firstTracker] = trackers;
  const reactGaOptions = {
    ...gaOptions,
    titleCase: false
  };

  ReactGA.initialize(firstTracker.trackingId, reactGaOptions);
  ReactGA.addTrackers(trackers);

  if (payspaceSlug) {
    ReactGA.set({
      // This is a custom dimension that must be created in the GA accounts.
      dimension1: payspaceSlug
    }, trackerNames);
  }

  function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
      ReactGA.pageview(location.pathname, trackerNames);
    }, [location.pathname]);

    return null;
  }

  return { AnalyticsTracker };
}
